<template>
  <div class="empty-slot px-2">
    <div class="empty-slot-content">
      <h5>{{ $t(emptyText) }}</h5>
      <p v-if="canAdd">{{ $t("tables.can-add") }}</p>
    </div>
    <img :src="`${path}/img/EmptyRoom.svg`" alt="Empty Room" />
  </div>
</template>

<script>
export default {
  name: "Search",
  props: {
    canAdd: {
      type: Boolean,
      default: false
    },
    emptyText: {
      type: String,
      default: "tables.empty-room"
    }
  },
  computed: {
    path() {
      return process.env.VUE_APP_PUBLIC_PATH || window.location.origin;
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-slot {
  position: relative;
  .empty-slot-content {
    font-size: 25px;
    text-align: center;
    position: absolute;
    width: 100%;
    margin-top: 90px;
    left: 0;
    p {
      font-size: 16px;
    }
  }
  img {
    max-height: 300px;
    width: 100%;
  }
}
</style>
